<template>
  <div class="homeCenter clearfix">
    <div class="titleBox">
      <h2>企业信息</h2>
      <p>管理您的信息，修改密码设置发票抬头等</p>
    </div>
    <div class="jiazaiBox" v-if="isLoading">
      <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div class="threeBox" v-if="!isLoading">
      <div class="box yuanjiao mb-3" style="min-height: auto;padding-bottom: 20px">
        <div class="row">
          <div class="col-sm-2 mb-2">
            <span class=""><b>代理商：</b></span>
          </div>
          <div class="col-sm-4 mb-2">
            {{dataInfo.moreInfo.company?dataInfo.moreInfo.company:'未配置...'}}
          </div>
          <div class="col-sm-2 mb-2">
            <span class=""><b>统一社会信用代码：</b></span>
          </div>
          <div class="col-sm-4 mb-2">
            {{dataInfo.moreInfo.code?dataInfo.moreInfo.code:'未配置...'}}
          </div>
          <div class="col-sm-2 mb-2">
            <span class=""><b>联系地址：</b></span>
          </div>
          <div class="col-sm-4 mb-2">
            {{dataInfo.moreInfo.address?dataInfo.moreInfo.address:'未配置...'}}
          </div>
          <div class="col-sm-2 mb-2">
            <span class=""><b>客户经理：</b></span>
          </div>
          <div class="col-sm-4 mb-2">
            {{dataInfo.moreInfo.manage?dataInfo.moreInfo.manage:'未配置...'}}
          </div>
        </div>
      </div>
      <div class="box yuanjiao">
        <dl class="row">
          <dt class="col-sm-3">头像</dt>
          <dd class="col-sm-9" :key="saveUploadView">
            <vue-core-image-upload v-if="!is_loading" :key='saveUploadView'
                                   :crop="false"
                                   :inputOfFile="'UploadFormfile[imgFile]'"
                                   @imageuploaded="imageuploadedReload"
                                   @imagechanged="imagechangedReload"
                                   @imageuploading='imageuploading'
                                   @errorhandle='errorhandle'
                                   inputAccept='image/*'
                                   :maxFileSize='uploadSize'
                                   input-of-file="file"
                                   :isXhr='false'
                                   :data="{str:localUser.token}"
                                   :headers="{Authorization:localUser.token}"
                                   :url="uploadUrl">
              <div v-if="dataInfo.headPortrait === ''" class="uploadBox"><i class="iconfont icon-plus"></i></div>
              <div v-if="dataInfo.headPortrait !== ''" class="uploadBox" :style="{backgroundImage: 'url('+ossImgDomain+dataInfo.headPortrait+')'}"></div>
            </vue-core-image-upload>
            <div v-if="is_loading" class="uploadBox">
              <span>{{loadingSize}}</span>
              <span>{{loadingProgress}}%</span>
            </div>
          </dd>
        </dl>
        <hr>
        <br>
        <dl class="row">
          <dt class="col-sm-3">员工名称</dt>
          <dd class="col-sm-9">{{dataInfo.name}}</dd>
          <dt class="col-sm-3">联系电话</dt>
          <dd class="col-sm-9">{{dataInfo.phone}}（<span class="">可用于重置密码</span>）</dd>
          <dt class="col-sm-3">登录账号</dt>
          <dd class="col-sm-9">
            <p>{{dataInfo.user}}</p>
            <hr>
            <p>
              <button type="button" @click="showModelBox('savepwd')" class="btn btn-outline-secondary btn-round">修改密码</button>
            </p>
          </dd>
        </dl>
        <hr>
        <br>
        <dl class="row">
          <dt class="col-sm-3">企业发票抬头</dt>
          <dd class="col-sm-9">
            <p>发票抬头：{{dataInfo.invoiceInfo.title?dataInfo.invoiceInfo.title:'...'}}</p>
            <p>纳税人识别号：{{dataInfo.invoiceInfo.code?dataInfo.invoiceInfo.code:'...'}}</p>
            <p>开户银行：{{dataInfo.invoiceInfo.bank?dataInfo.invoiceInfo.bank:'...'}}</p>
            <p>银行账号：{{dataInfo.invoiceInfo.bankCode?dataInfo.invoiceInfo.bankCode:'...'}}</p>
            <p>注册电话：{{dataInfo.invoiceInfo.registerPhone?dataInfo.invoiceInfo.registerPhone:'...'}}</p>
            <p>注册地址：{{dataInfo.invoiceInfo.registerAddress?dataInfo.invoiceInfo.registerAddress:'...'}}</p>
            <hr>
            <p>
              <button type="button" @click="showModelBox('saveinvoice')" class="btn btn-outline-secondary btn-round">修改抬头</button>
            </p>
          </dd>
        </dl>
        <hr>
        <br>
        <dl class="row">
          <dt class="col-sm-3">个人发票抬头</dt>
          <dd class="col-sm-9">
            <p>发票抬头：{{dataInfo.invoiceInfo.person?dataInfo.invoiceInfo.person:'...'}}</p>
            <hr>
            <p>
              <button type="button" @click="showModelBox('saveinvoiceperson')" class="btn btn-outline-secondary btn-round">修改抬头</button>
            </p>
          </dd>
        </dl>

        <hr>
        <br>
        <dl class="row">
          <dt class="col-sm-3">预定义收件地址</dt>
          <dd class="col-sm-9">
            <p>收件人：{{dataInfo.invoiceInfo.mailName?dataInfo.invoiceInfo.mailName:'...'}}</p>
            <p>收件电话：{{dataInfo.invoiceInfo.mailPhone?dataInfo.invoiceInfo.mailPhone:'...'}}</p>
            <p>收件地址：{{dataInfo.invoiceInfo.mailAddress?dataInfo.invoiceInfo.mailAddress:'...'}}</p>
            <hr>
            <p>
              <button type="button" @click="showModelBox('saveinvoicepost')" class="btn btn-outline-secondary btn-round">修改信息</button>
            </p>
          </dd>
        </dl>
      </div>
    </div>
    <transition appear mode='out-in' enter-active-class='animated animated2 slideInRight' leave-active-class='animated animated2 slideOutRight'>
      <div v-if="isShowRightBox" class="rightBox" @click.self="closeRightBoxFun">
        <component :hide="false" :apiCrmdatainfo="apiCrmdatainfo" :closeRightBoxFun="closeRightBoxFun" :is="isCompnentElement"></component>
      </div>
    </transition>
  </div>
</template>

<script>
import { EventBus } from '@/util/eventBus';
import uiSavepwd from '@/components/common/user/Savepwd';
import uiSaveinvoice from '@/components/common/user/Saveinvoice';
import uiSaveinvoiceperson from '@/components/common/user/Saveinvoiceperson';
import uiSaveinvoicepost from '@/components/common/user/Saveinvoicepost';
import generalMix from '@/util/mix/general';
import VueCoreImageUpload from 'vue-core-image-upload'; // 图片上传组件
import commons from '@/util/commons';
import resultcommons from '../../util/resultcommons'; // 引入通用函数
import * as types from '@/store/types';

export default {
  name: 'homeCenter',
  mixins: [generalMix],
  data () {
    return {
      // 获取数据
      dataInfo:{},
      isLoading:true,
      // 状态
      isShowRightBox: false,
      isCompnentElement: '',
      // 上传状态参数
      uploadUrl: process.env.IMAGE_UPLOAD_URL, // 图片上传地址
      uploadSize: process.env.IMAGE_UPLOAD_SIZE,
      ossImgDomain: process.env.OSS_IMG_DOMAIN,
      is_loading: false, // 上传按钮状态
      loadingSize: '0 B', // 文件大小
      loadingProgress: 0, // 上传进度
      saveUploadView: 0
    }
  },
  methods:{
    // 获取基本信息
    apiCrmdatainfo(bool = true) {
      if(bool){
        EventBus.$emit('globalLoadingFun', {bool:true,loading:true});
      }
      return resultcommons.apiCrmdatainfo(this,{}).then(app=>{
        if(app.state === 200){
          this.dataInfo = app.data;
        }else{
          // 请求失败
          this.$message.showMsgBox({
            type: 'warning',
            content: '请求失败'
          });
        }
        if(bool){
          EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
        }
      });
    },
    imageuploadedReload(res) {
    },
    imagechangedReload(ob) {
      commons.makeTupianOneImgShard(this, ob, { token: this.token, type: 'crmdataheadimg', initFun: this.initUploadSuccess }, 'reload');
    },
    imageuploading() {
      // 上传中
    },
    errorhandle(message) {
      // 上传选择后
      this.$message.showMsgBox({
        type: 'danger',
        content: message
      });
      this.is_loading = false;
      this.saveUploadView = this.saveUploadView + 1;
    },
    // 初始化详情
    initUploadSuccess(ob) {
      // 成功的话就执行更新请求
      if(ob.state === 200){
        this.is_loading = true;
        EventBus.$emit('globalLoadingFun', {bool:true,loading:true});
        resultcommons.apiSaveheadportrait(this,{path:ob.data.path}).then(app=>{
          if(app.state === 200){
            // 更新本地缓存
            const localOb = this.localUser;
            localOb.headPortrait = app.data.headPortrait;
            commons.saveTodos('localUser', localOb);
            // 更新本地路由的登录信息
            this.$store.commit(types.SAVE_LOCALUSER, { bool: true });
            // 提示
            this.$message.showMsgBox({
              type: 'success',
              content: app.message
            });
          }else{
            // 提示
            this.$message.showMsgBox({
              type: 'warning',
              content: app.message
            });
          }
          this.apiCrmdatainfo();
          this.is_loading = false;
          EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
        });
      }
    },
    showModelBox(type) {
      if(type === 'savepwd'){
        this.isCompnentElement = 'ui-savepwd';
      }else if(type === 'saveinvoiceperson'){
        this.isCompnentElement = 'ui-saveinvoice-person';
      }else if(type === 'saveinvoicepost'){
        this.isCompnentElement = 'ui-saveinvoice-post';
      }else{
        this.isCompnentElement = 'ui-saveinvoice';
      }
      $('html').addClass('scrollHide');
      this.isShowRightBox = true;
    },
    closeRightBoxFun() {
      this.isShowRightBox = false;
      this.isCompnentElement = '';
      $('html').removeClass('scrollHide');
    },
    showWeicode(ob) {
      EventBus.$emit('globalRightBoxFun', ob);
    }
  },
  components: {
    'ui-savepwd': uiSavepwd,
    'ui-saveinvoice': uiSaveinvoice,
    'ui-saveinvoice-person': uiSaveinvoiceperson,
    'ui-saveinvoice-post': uiSaveinvoicepost,
    VueCoreImageUpload
  },
  created() {
    this.isLoading = true;
    this.apiCrmdatainfo(false).then(app=>{
      this.isLoading = false;
    });
  },
  mounted() {
    $('html').removeClass('scrollHide');
  },
  destroyed() {
  }
}
</script>

<style scoped lang='less'>

.homeCenter {

  div.uploadBox{
    width: 96px;
    height: 96px;
    border-radius: 50%;
    background-color: #E5E5E5;
    display: flex;
    justify-content: center;
    align-items: center;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    flex-direction: column;
    i{
      font-size: 32px;
      color: rgba(0,0,0,0.5);
    }
    span{
      display: block;
      width: 100%;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 0 5px;
    }
  }

  .rightBox{
    position: fixed;
    height: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 4;
  }

  .titleBox {
    margin-top: 30px;
    color: #FFFFFF;
    margin-bottom: 30px;
    p {
      margin: 0;
      color: rgba(255, 255, 255, 0.5);
    }
  }
  div.threeBox {
    margin-top: 20px;
    color: #000000;
    div.box {
      min-height: 100vh;
      background: #FFFFFF;
      padding: 40px 40px;
      box-shadow: 0 .75rem 1.5rem rgba(18, 38, 63, .03);
      div.lis{
        margin-bottom: 50px;
        h4{
          margin-bottom: 20px;
        }
        div.content{
          margin-bottom: 10px;
        }
        div.anli{
          margin-top: 20px;
          display: flex;
          div.card{
            background: #FFFFFF url("/static/images/engage.svg") no-repeat 115px 110px;
            background-size: 65px;
            &:first-child{
              margin-right: 20px;
            }
          }
        }
        ul{
          li{
            float: left;
            margin-right: 15px;
            &:after{
              margin-left: 15px;
              display: inline-block;
              content: '->';
            }
            &:last-child{
              margin: 0;
              &:after{
                display: none;
              }
            }
          }
        }
        &:last-child{
          margin: 0;
        }
      }
    }
  }
  div.jiazaiBox{
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
    background: #FFFFFF;
    min-height: 100vh;
    .spinner-border{
      width: 3rem;
      height: 3rem;
      color: red;
    }
  }
}

@media (max-width: 992px) {
  .homeCenter{
    .titleBox {
      margin-top: 30px;
      margin-bottom: 30px;
      p {
        margin: 0;
        color: #999999;
      }
    }
    div.threeBox {
      margin-top: 20px;
      div.box {
        background: #FFFFFF;
        padding: 20px 20px;
      }
    }
  }
}

@media (max-width: 767px) {
  .homeCenter{
    .titleBox {
      margin-top: 50px;
      text-align: center;
      p{
        padding: 0 15px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/advantage/Center.vue